import { createContext } from "react";

export const SetDialogContext = createContext((dialogParams) => dialogParams);
